"use client"

import { cn } from "@/lib/utils"

interface BackgroundProps {
  className?: string
  variant?: "default" | "subtle" | "grid"
}

export function CrystalityBackground({ className, variant = "default" }: BackgroundProps) {
  return (
    <div className={cn("fixed inset-0 -z-10 overflow-hidden", className)}>
      {/* Base dark background */}
      <div className="absolute inset-0 bg-background" />
      
      {/* Grid pattern */}
      {variant === "grid" && (
        <div className="absolute inset-0 bg-grid-pattern opacity-50" />
      )}
      
      {/* Purple glow orbs */}
      <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] -translate-y-1/2" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] translate-y-1/2" />
      
      {/* Additional ambient glows */}
      {variant === "default" && (
        <>
          <div className="absolute top-1/3 right-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-[80px]" />
          <div className="absolute bottom-1/4 left-0 w-[300px] h-[300px] bg-primary/5 rounded-full blur-[60px]" />
        </>
      )}
      
      {/* Noise texture overlay */}
      <div 
        className="absolute inset-0 opacity-[0.015]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />
    </div>
  )
}

// Alias for backward compatibility
export const Background = CrystalityBackground
